/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable react/jsx-no-target-blank */
import '../styles/footer.scss';
import config from '../config/config.json';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { useState } from 'react';
import ModalFooter from './ModalFooter';

export default function Footer(){
    const { t } = useTranslation();
    const [modalType, setModalType] = useState(null);

    return(
        <footer class="footer">
        <div class="container">
            <div class="row mb-5">
                <div class="col-sm-12 col-md-5">
                    <div class="logo-container"></div>
                    <div class="address-block">
                    <div>Centrico-India Private Limited</div>
                    4th Floor, Block 1, Tyche Towers, 2, MGR Salai (S. No. N14/1A, 14/1B, 14/2A1 & 14/2A2, Perungudi Bypass Road), Kandanchavadi, <div>Chennai – 600 096, India</div>
                    <div>CIN : U72501TN2019FTC129878</div>
                    <div>+91 91768 91091</div>
                    </div>
                    <div class="linkedin-icon">
                        <a href="https://www.linkedin.com/company/centrico-india/" target="_blank" class="icon"></a>
                    </div>
                </div>
                <div class="col-sm-12 col-md-7">
                    <div class="row">
                        <div class="col-sm-12 col-md-4">
                            <div class="nav-items">
                            <div class="menu-title">{t('header.menu.whoweare')}</div>
                            <ul>
                                {config['header']['menu']['whoweare'].map((item, id) => {
                                    return (<li><Link to={item.path}>{t(`header.menu.${item.id}`)}</Link></li>)
                                })}
                            </ul>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="nav-items">
                            <div class="menu-title">{t('header.menu.whatwedo')}</div>
                            <ul>
                                {config['header']['menu']['whatwedo'].map((item, id) => {
                                    return (<li><Link to={item.path}>{t(`header.menu.${item.id}`)}</Link></li>)
                                })}
                            </ul>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <div class="nav-items">
                            <div class="menu-title">{t('header.menu.lifeatcentrico')}</div>
                            <ul>
                                {config['header']['menu']['lifeatcentrico'].map((item, id) => {
                                    return (<li><Link to={item.path}>{t(`header.menu.${item.id}`)}</Link></li>)
                                })}
                            </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="divider"></div>
            <div class="row">
            <div class="col-md-6">
                <div class="copyright">
                <p>Copyright &copy;2023 <span>Centrico-India</span> Private Limited</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="links">
                <a href="#">Our Policies</a>
                <a href="#">Terms & Conditions</a>
                <ul style={{listStyleType: 'none'}}>
                    <li><a href="/en/privacy-policy.html" target='_blank'>Privacy</a></li>
                    <li><a href='' onClick={(e) => {e.preventDefault(); setModalType('cookie');}}>Cookie Policy</a></li>
                    <li><a href='' onClick={(e) => {e.preventDefault(); setModalType('legal');}}>Legal Terms</a></li>
                    <li><a href={`${process.env.PUBLIC_URL}/Codice_etico_en.pdf`} target="_blank">Code Of Ethics</a></li>
                    <li><a href="/en/whistleblowing.html" target="_blank">Whistleblowing</a></li>
                    <li><a href={`${process.env.PUBLIC_URL}/ENG_MOG%20231%20Centrico_General%20Part.pdf`} target="_blank">MOG 231</a></li>
                </ul>
                </div>
            </div>
            </div>
        </div>
        <ModalFooter modalType={modalType} onHide={() => setModalType(null)} />
        </footer>
    )
}